export const tipoDeCliente = {
  Lead: 'Lead',
  Contato: 'Contato',
  LeadRepresado: 'LeadRepresado',
} as const
export type TTipoDeCliente = (typeof tipoDeCliente)[keyof typeof tipoDeCliente]

export const origemTelefone = {
  Brasil: 'Brasil',
  Internacional: 'Internacional',
} as const
export type TOrigemTelefone = (typeof origemTelefone)[keyof typeof origemTelefone]

export const EstadoCivilEnum = {
  CivilSolteiro: 'CivilSolteiro',
  CivilCasado: 'CivilCasado',
  CivilDivorciado: 'CivilDivorciado',
  CivilViuvo: 'CivilViuvo',
  CivilUniaoEstavel: 'CivilUniaoEstavel',
  CivilSeparadoJudicialmente: 'CivilSeparadoJudicialmente',
} as const
export type TEstadoCivilEnum = (typeof EstadoCivilEnum)[keyof typeof EstadoCivilEnum]
